import ApiReceiver from './ApiReceiver';
import PutCommand from './PutCommand';

class PostCommand<T> extends PutCommand<T> {
  constructor(apiReceiver: ApiReceiver, path: string, data: T, identifier: string) {
    super(apiReceiver, path, data, identifier);
  }

  // PutCommand method override
  handleApiCall(path: string, data: T): Promise<T> {
    return this.apiReceiver.postData<T>(path, data);
  }
}

export default PostCommand;
